export default __webpack_public_path__ + "static/media/mednear.9f4d5eaf.png";